/**
 * File: defaultValues.js
 * Project: Aitea-Building
 * File Created: Thursday, 30th May 2024 9:58:52 am
 * Author: Jorge Sierra Blázquez (jorge.sierra@aerin.es)
 * Version: 1.0.0
 * -----
 * Last Modified: Friday, 11th April 2025 10:52:20 am
 * Modified By: Daniel Rodríguez Cabrera
 * -----
 * Copyright (c) 2023 - 2024 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 *
 */

/*
IMPORTANTE: No editar este archivo en noname-base-frontend 
debido a que al copiar el modulo este lo reemplazara.
*/
// import {filterUrls} from "helpers/Utils";

import { menusByPermissions } from 'helpers/Utils';

export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

// Variable de la paginación de tablas

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
// bcp47: tag BCP-47 del idioma, usado por Intl (formateo de números/fechas) y por
// cualquier formulario que necesite la lista de idiomas en ese formato (p.ej. "es-ES").
// Añadir un idioma nuevo aquí es suficiente para que aparezca también en esos sitios.
export const localeOptions = [
  { id: 'es', name: 'Español', direction: 'ltr', bcp47: 'es-ES' },
  { id: 'en', name: 'English', direction: 'ltr', bcp47: 'en-US' },
  { id: 'ca', name: 'Català', direction: 'ltr', bcp47: 'ca-ES' },
  { id: 'fr', name: 'Français', direction: 'ltr', bcp47: 'fr-FR' },
  { id: 'it', name: 'Italiano', direction: 'ltr', bcp47: 'it-IT' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const adminRoot = '/app';
export const loginRoot = '/user/login';

export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/pages/miscellaneous/search`;
export const servicePath = 'https://api.coloredstrategies.com';
export const permissionDenied = '/error';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'dark.aiteabuilding';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  /*
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
  */
  'bluenoname',
  'pinknoname',
  'greennoname',
  'orangenoname',
];
// Este fichero pisa el del framework, así que tiene que seguir exportando lo que el framework
// importa: `helpers/Utils.js` de develop importa `adminMenus` (lo usa `isSuperUserMenus`).
// Aquí no se usa, pero quitarlo rompe el build del framework.
export const adminMenus = [''];

// Aitea Building quita «Mi cuenta» de la barra lateral: se entra desde la barra de arriba.
// Es un gancho del framework, así que en otros productos la entrada sigue saliendo.
const HIDDEN_MENU_IDS = ['global.myaccount.edit'];
export const customFilter = (items) =>
  items.filter((item) => !HIDDEN_MENU_IDS.includes(item.id));

// Orden de prioridades: building > synthetic > tag > writeBacnet > tagCategories
// Usuarios, perfiles y mi cuenta ya no están aquí: los sirve el módulo de cuentas,
// cada uno en su propia pantalla del menú.
export const tabPriority = [
  { permission: 'building', tab: 'buildings' },
  { permission: 'synthetic', tab: 'synthetic_data' },
  { permission: 'tag', tab: 'tags' },
  { permission: 'writeBacnet', tab: 'bacnet_command' },
  { permission: 'tagCategories', tab: 'tags_category' },
];

export const getRedirectPath = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('gogo_current_user'));
    if (!userData || !userData.user_permissions) {
      return '/error';
    }
    const permissions = userData.user_permissions;

    // Definir el orden de prioridad de los permisos
    const permissionRoutes = {
      'aiteabuilding.data.view': '/data',
      'global.assistant.use': '/home-aiteaassistant',
      'global.dashboards.view': '/default/advanced-dashboard/dashboard-list',
      'aiteabuilding.syntheticdata.manage': '/synthetic-data',
      'aiteabuilding.admin.view':
        '/administration-aiteabuilding/administration-dashboard',
      'aiteabuilding.events.view': '/events',
      'aiteabuilding.tags.view': '/tags',
    };

    // Buscar la primera clave que el usuario tenga en sus permisos
    const permission = Object.keys(permissionRoutes).find((key) =>
      permissions.includes(key),
    );

    return permission ? permissionRoutes[permission] : '/my-account';
  } catch (error) {
    console.error('Error procesando permisos:', error);
    return '/error';
  }
};

// CONTRATO: solo funciona interpolado en una cadena (`${match.url}${actualRedirect}`, en
// `views/app/index.js` del framework), que llama a `toString()` y calcula la página con el
// usuario que haya en ese momento. Usado suelto es un objeto: para eso, `getRedirectPath()`.
// No es una constante porque este fichero se carga antes del login, sin usuario.
export const actualRedirect = { toString: () => getRedirectPath() };

// El menú se filtra siempre por los permisos de quien entra.
export const menuFunction = menusByPermissions;
